<template>
  <div class="container">
    <div class="head">
        <div class="title">
          <div class="text">游客体验满意度</div>
          <div class="branch">-0.3</div>
        </div>
        <div class="tip">
          <div class="con">大理州-大理市</div>
          <div class="con">一类地区</div>
        </div>
        <div class="date">2019-11-01 12:31:22</div>
      </div>
    <div class="pg-pd12">
      <causeDeduction  :causeContent="causeContent"></causeDeduction>
    <!-- 相关材料 -->
      <materialScience :caseList="assessFile"></materialScience>
   </div>
  </div>
</template>
<script>
    import causeDeduction from './components/causeDeduction';// 扣分原因
    import materialScience from './components/materialScience';// 相关材料
    import api from '../../service/modules/appraise';

    export default {
        components: {
            causeDeduction, materialScience
        },

        data () {
            return {
                // 相关材料列表
                assessFile: [
                    { fileName: '文化和旅游', fileType: 'pdf', download_url: 'http://127.0.0.1:8080/swf/project/13769245747/6DAC1564-B88C-EE50-6BF8-5CA316622774/20191018143255_XXXX/20191018143255.pdf' },
                    { fileName: '公安一', fileType: 'doc', download_url: 'http://127.0.0.1:8080/swf/project/13769245747/6DAC1564-B88C-EE50-6BF8-5CA316622774/20191018143255_XXXX/20191018143255.pdf' },
                    { fileName: '公安一', fileType: 'exl', download_url: 'http://127.0.0.1:8080/swf/project/13769245747/6DAC1564-B88C-EE50-6BF8-5CA316622774/20191018143255_XXXX/20191018143255.pdf' }
                ],
                causeContent: '暂无'

            }
        },

        computed: {},

        watch: {},

        methods: {
            // 考核明细接口
            getSubAssessDetail () {
                api.getAssessDetailById({ id: '335C6B06-33CA-D7E4-B539-C35B6B9BA99E', complainId: '201907141721243498431', subType: 'A1' }).then(res => {
                    if (res.ret === 0) {
                        this.assessDetail = res.data.assessDetail
                        this.causeContent = res.data.assessDetail.deductionReason// 扣分原因
                        this.complainRateInfo = res.data.assessDetail.complainRateInfo// 投诉率详情
                        this.tableList = res.data.assessDetail.complainRateList // 州市投诉率列表
                    } else {
                        this.$Message.error(res.data.msg)
                    }
                });
            },
            navTo () {
                this.$router.push({
                    path: '/appraise/scoreList'
                })
            }
        },

        mounted () {
        },

        created () {}

    }
</script>
<style scoped lang="less">
  .container {
    min-height: 100vh;
    background: rgba(251, 251, 251, 1);
    padding-bottom: 24px;
  .pg-pd12 {
      padding-left: 12px;
      padding-right: 12px;

    }
        .head{
          width: 100%;
          background: #fff;
          padding: 24px 12px;
          margin-bottom: 24px;
          .title{
            height:22px;
            line-height: 22px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .text{
              font-size:20px;
              font-family:PingFangSC-Medium,PingFang SC;
              font-weight:500;
              color:rgba(51,51,51,1);
              line-height:20px;
            }
            .branch{
              height:22px;
              font-size:22px;
              font-family:DIN-Medium,DIN;
              font-weight:500;
              color:rgba(255,77,77,1);
              line-height:22px;
            }
        }
        .tip{
          margin-top:12px;
          display: flex;
          font-size:10px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(54,179,116,1);
          .con{
            border:1Px solid rgba(54,179,116,1);
            padding: 2px 4px;
            margin-right:14px;
          }
        }
        .date{
          margin-top:12px;
          font-size:12px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(153,153,153,1);
          line-height:12px;
        }
    }

  }
</style>
